import Swal from 'sweetalert2';
import axios from 'axios';
import { API_BASE_URL } from '../config';

/**
 * [Alışveriş Hatırlatma] Liste oluştuktan sonra "hatırlatma kuralım mı?" ikinci modalı.
 * Evet → seçilen saatte GERÇEK push (backend ShoppingReminderService dispatch eder).
 * Tüm haftalık-alışveriş mutfaklarında ortak (alakart + diyet + sporcu).
 *
 * Varsayılan saat: yaklaşan ilk öğle 13:00; bugün 13:00 geçtiyse yarın 13:00.
 */

function defaultReminderDateTime() {
  const now = new Date();
  const d = new Date(now);
  if (now.getHours() >= 13) d.setDate(d.getDate() + 1); // bugün öğle geçtiyse yarına
  d.setHours(13, 0, 0, 0);
  const pad = (n) => String(n).padStart(2, '0');
  return {
    date: `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`,
    time: '13:00'
  };
}

/**
 * @param {number} listId  oluşturulan listenin id'si
 * @param {string} listName  push mesajında geçecek liste adı
 * @param {{confirmColor?: string}} opts
 * @returns {Promise<{date:string,time:string}|null>}
 */
export async function promptAndSetShoppingReminder(listId, listName, { confirmColor = '#16a34a' } = {}) {
  if (!listId) return null;
  const def = defaultReminderDateTime();
  const safeName = (listName || 'Listeniz').toString();

  const result = await Swal.fire({
    title: 'Hatırlatma Kuralım mı? 🔔',
    html: `
      <p style="margin-bottom:14px;line-height:1.5">
        <b>${safeName}</b> için alışveriş hatırlatması kuralım mı?<br/>
        Seçtiğin saatte telefonuna bildirim göndereceğim.
      </p>
      <div style="display:flex;gap:8px;justify-content:center;align-items:center;flex-wrap:wrap">
        <input id="rmd-date" type="date" value="${def.date}" class="swal2-input" style="width:auto;margin:0" />
        <input id="rmd-time" type="time" value="${def.time}" class="swal2-input" style="width:auto;margin:0" />
      </div>`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Evet, hatırlat',
    cancelButtonText: 'Hayır, gerek yok',
    confirmButtonColor: confirmColor,
    reverseButtons: true,
    allowOutsideClick: false,
    allowEscapeKey: false,
    preConfirm: () => {
      const date = document.getElementById('rmd-date')?.value;
      const time = document.getElementById('rmd-time')?.value;
      if (!date || !time) { Swal.showValidationMessage('Tarih ve saat seçmelisin'); return false; }
      const dt = new Date(`${date}T${time}:00`);
      if (Number.isNaN(dt.getTime()) || dt.getTime() <= Date.now()) {
        Swal.showValidationMessage('Lütfen gelecekte bir zaman seç'); return false;
      }
      return { date, time };
    }
  });

  if (!result.isConfirmed || !result.value) return null;

  try {
    const token = localStorage.getItem('authToken');
    await axios.post(`${API_BASE_URL}/api/shopping/lists/${listId}/reminder`, result.value, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const dt = new Date(`${result.value.date}T${result.value.time}:00`);
    await Swal.fire({
      title: 'Hatırlatma Kuruldu! 🔔',
      html: `${dt.toLocaleString('tr-TR', { dateStyle: 'medium', timeStyle: 'short' })} zamanında sana bildirim göndereceğim.`,
      icon: 'success',
      confirmButtonText: 'Tamam',
      confirmButtonColor: confirmColor
    });
    return result.value;
  } catch (e) {
    console.error('Shopping reminder set error:', e);
    Swal.fire('Hata', 'Hatırlatma kurulamadı.', 'error');
    return null;
  }
}
